import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: true,                                   
  selector: 'app-code-modal',
  templateUrl: './code-modal.component.html',
  styleUrls: ['./code-modal.component.scss'],
  imports: [CommonModule, FormsModule]                
})

export class CodeModalComponent {
  code = '';

  constructor(public activeModal: NgbActiveModal) {}

  submit(): void {
    const codeValue = this.code.trim() || null;
    this.activeModal.close(codeValue);
  }
  
  close(): void {
    this.activeModal.close(null);
  }
}